var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"star-container ml-2 mb-2"},[_c('img',{attrs:{"src":require("@/assets/diamond.svg"),"height":"20px","alt":"Diamond"}}),_c('span',{staticClass:"ml-2"},[_vm._v("Premium Page")])])
}]

export { render, staticRenderFns }